module.exports = __webpack_public_path__ + "static/img/tit.d9659ef8.png";